export class SchedulesService {
  constructor (api) {
    this.api = api
  }

  getSchedules = () => this.api.get('/schedules?assetType=DEVCONFIG-text/xml-hon-license-config')
}
